// EJS using this tab framework must implement"
// fn initializeTab(tabId)
// fn tabWillShow(tabId)

function initializeTabs() {
    $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        tabSelected($(e.target).attr("data-target").replace("#", ""));
    });
}

function selectInitialTab() {
    // select a tab if in the hash, otherwise pick the first tab
    var tabHref = document.location.hash;

    // is this a valid tab? If not, just get the first tab
    if (
        !(tabHref && $('.nav-tabs a[data-target="' + tabHref + '"]').length > 0)
    ) {
        tabHref = $(".content-tabs.nav-tabs li:first-child a").data("target");
    }

    $('.nav-tabs a[data-target="' + tabHref + '"]').tab("show");
}

function selectTab(tabId) {
    $('.nav-tabs a[data-target="#' + tabId + '"]').tab("show");
}

let _areTabsInitialized = {};

function tabSelected(tabId) {
    history.replaceState(undefined, undefined, "#" + tabId);

    var isInitialized = _areTabsInitialized[tabId] === true;

    if (!isInitialized) {
        initializeTab(tabId);
    }

    tabWillShow(tabId);

    _areTabsInitialized[tabId] = true;
}

module.exports = {
    initializeTabs,
    selectInitialTab,
    selectTab,
    tabSelected,
};
